module.exports = __webpack_public_path__ + "static/img/like_0.0ba626c3.svg";